import Image from "next/image";
import { IconProps } from "./types";

export const SearchIcon = ({ altText }: IconProps) => {
  return (
    <Image src={"/search-icon.svg"} alt={altText} width={24} height={24} />
  );
};
